webpackJsonp([8245513591088],{

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	var _Tip = __webpack_require__(26);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Alle onderstaande vormen worden gemaakt met de",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "/spqr/leerdoelen/8b" },
	          "praesensstam"
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "praesens"
	          ),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "imperfectum"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "futurum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "a-/e-groep"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "i-/mk-groep"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>valt de a- weg" },
	              "or"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013r"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "b\u2013or"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "a\u2013r"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "be\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013ris"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "3e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013tur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mini"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "3e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ba\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "bu\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "e\u2013ntur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik word gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik werd gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 2 },
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik zal worden gegeten"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	var _Tip = __webpack_require__(26);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Alle onderstaande vormen worden gemaakt met de",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "/spqr/leerdoelen/8b" },
	          "praesensstam"
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 4 },
	            "indicativus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "praesens"
	          ),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "imperfectum"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "futurum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "a-/e-groep"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "i-/mk-groep"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>valt de a- weg" },
	              "or"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013r"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "b\u2013or"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "a\u2013r"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "be\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013ris"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "3e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013tur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mini"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "3e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ba\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "bu\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "e\u2013ntur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik word gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik werd gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 2 },
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik zal worden gegeten"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "conjunctivus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "praesens"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013r"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013ris"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "3e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013tur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013mur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013mini"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "3e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013ntur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik word gegeten"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	var _Tip = __webpack_require__(26);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Alle onderstaande vormen worden gemaakt met de",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "/spqr/leerdoelen/8b" },
	          "praesensstam"
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 4 },
	            "indicativus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "praesens"
	          ),
	          _react2.default.createElement(
	            "th",
	            { rowSpan: 2 },
	            "imperfectum"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "futurum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "a-/e-groep"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "i-/mk-groep"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>valt de a- weg" },
	              "or"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013r"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "b\u2013or"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "a\u2013r"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "be\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013ris"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "3e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013tur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ba\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "bi\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "e\u2013mini"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "3e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ba\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "bu\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "e\u2013ntur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik word gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik werd gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 2 },
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik zal worden gegeten"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 4 },
	            "conjunctivus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "praesens"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "imperfectum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013r"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "re\u2013r"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013ris"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "re\u2013ris"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "3e ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013tur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "re\u2013tur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "1e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013mur"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "re\u2013mur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "2e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013mini"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "re\u2013mini"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "3e mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            " ",
	            _react2.default.createElement(
	              _Tip2.default,
	              { tip: "bij a-stammen<br/>is dit een e-" },
	              "a"
	            ),
	            "\u2013ntur"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "re\u2013ntur"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik word gegeten"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik werd gegeten"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _onvPass = __webpack_require__(659);
	
	var _onvPass2 = _interopRequireDefault(_onvPass);
	
	var _onvPass3 = __webpack_require__(660);
	
	var _onvPass4 = _interopRequireDefault(_onvPass3);
	
	var _onvPass5 = __webpack_require__(661);
	
	var _onvPass6 = _interopRequireDefault(_onvPass5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "30",
	  table: _onvPass2.default
	}, {
	  les: "43",
	  table: _onvPass4.default
	}, {
	  les: "44",
	  table: _onvPass6.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, { defaultChapter: "44", data: data, title: "Onvoltooid passief" });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-onvoltooid-passief-js-2835e72e96f296874130.js